import { PudoLocation } from '@pperform/pp-data-mappers';
import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import {
  getReturnDropOffLocations,
  bookReturn as bookReturnFetcher,
} from '../fetchers';

export const bookReturn = async ({
  orgId,
  orgName,
  collectionPoint,
  shipmentPk,
  shipmentUuid,
  returnUuid,
  returnStatus,
  bookingCount,
}: {
  orgId: number;
  orgName: string;
  collectionPoint: PudoLocation;
  shipmentPk: number;
  shipmentUuid: string;
  returnUuid: string;
  returnStatus: string;
  bookingCount: number;
}): Promise<any> => {
  try {
    const { address, carrier, pudoLocationId } = collectionPoint;

    await bookReturnFetcher(orgId, {
      pudo_location: {
        carrier: {
          carrier_id: carrier?.carrierId,
          carrier_references: carrier?.carrierReferences,
        },
        address: {
          company: orgName,
          location_type: address.locationType,
          country: address.country,
          region: address.region,
          state_or_province: address.stateOrProvince,
          city: address.city,
          postal_code: address.postalCode,
          line1: address.line1,
          line2: address.line2,
        },
        pudo_location_id: pudoLocationId,
      },
      shipment: {
        id: shipmentPk,
        shipment_uuid: shipmentUuid,
      },
      return: {
        return_uuid: returnUuid,
        return_status: returnStatus,
        booking_count: bookingCount,
      },
    });
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }

    throw error;
  }
};

interface DropOffLocations {
  locations: PudoLocation[];
}

export const searchDropOffLocations = async (
  orgSlug: string,
  orgId: number,
  values: { postalCode: string; countryCode: string },
): Promise<DropOffLocations> => {
  try {
    const { data: collectionPoints } = await getReturnDropOffLocations(orgId, {
      organization_slug: orgSlug,
      postal_code: values.postalCode,
      country_code: values.countryCode,
    });

    const locations: PudoLocation[] = collectionPoints
      .map((dto): PudoLocation => PudoLocation.fromApiData(dto))
      .sort((obj1: PudoLocation, obj2: PudoLocation) =>
        (obj1.address?.addressName || '').localeCompare(
          obj2.address?.addressName || '',
        ),
      );

    return { locations };
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }

    throw error;
  }
};
